import * as React from 'react';
import { TCustomRadioGroup } from './CustomRadioGroup.types';
import '../../../../ProductItem.styled.scss';

export const CustomRadioGroup: TCustomRadioGroup = ({
  productCustomField,
  value,
  onChange,
}) => {
  const options = productCustomField.options || [];
  const selectedValue = value || '';

  const handleOptionClick = (optionId: string) => {
    if (onChange) {
      onChange(optionId);
    }
  };

  return (
    <div className="product-item__custom-fields-radio-group">
      {options.map((option) => {
        const isSelected = selectedValue === option.id;
        return (
          <div
            key={option.id}
            className={`product-item__custom-fields-radio-group-option ${
              isSelected
                ? 'product-item__custom-fields-radio-group-option--selected'
                : ''
            }`}
            onClick={() => handleOptionClick(option.id)}
          >
            {option.color && (
              <div
                className="product-item__custom-fields-radio-group-option-color-circle"
                style={{ backgroundColor: option.color }}
              />
            )}
            <span>{option.name}</span>
          </div>
        );
      })}
    </div>
  );
};
